import { Component } from '@angular/core';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { Globals } from '../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';
import { SuperClass } from '../../../superclass/SuperClass';
import { DataTable } from 'primeng/primeng';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.css'],
})
export class ChangeLogComponent extends SuperClass {
  users;
  start;
  end;
  changes: any;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      {
        label: 'Change Log',
        routerLink: [{ outlets: { sub: [RouterConst.CHANGE_LOG] } }],
      },
    ]);

    this.end = new Date();
    this.start = new Date(this.end.getTime() - 24 * 60 * 60 * 1000);
  }

  reloadData() {
    this.http_getChanges((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.changes = data.payload;
      }
    });
    this.http_getAllAnalyticUsers((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.users = data.payload;
      }
    });
  }

  getDate(date) {
    return new Date(date);
  }

  unselectRow() {}

  activityReport() {
    this.http_getActivityReport(
      /*this.reportUser.username*/ 'yowireless',
      this.start.getTime(),
      this.end.getTime(),
      (data: any) => {
        console.log(data);
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          console.log(data.payload);
          const fileBlob = data.blob();
          const blob = new Blob([fileBlob], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
        }
      },
    );
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/change-log/change-log.component.ts